import { Action, Reducer } from 'redux';
import {
  AutomaticActionActionTypes,
  AutomaticActionData,
  AutomaticActionState,
  AutomaticActionsTypes
} from './automaticActionTypes';
import { AutomaticActionEnum } from '@/main/services/enum/AutomaticActionEnum';

function removeByEnum(value: AutomaticActionEnum, currenteData: AutomaticActionData[]) {
  return currenteData.filter(x => x.idAction != value)
}

function removeById(value: string, currenteData: AutomaticActionData[]) {
  return currenteData.filter(x => x.id != value)
}
export const INITIAL_STATE: AutomaticActionState = {
  automaticAction: {
    data: null
  }
};

const automaticActionReducer: Reducer<AutomaticActionState> = (
  state: AutomaticActionState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as AutomaticActionActionTypes;
  switch (actionTypes.type) {
    case AutomaticActionsTypes.GET_AUTOMATIC_ACTION:
      return {
        ...state,
        automaticAction: { ...state.automaticAction }
      };

    case AutomaticActionsTypes.SAVE_AUTOMATIC_ACTION:

      return {
        ...state,
        automaticAction: {
          ...state.automaticAction,
          data: [...(state.automaticAction?.data ?? []), actionTypes.payload.data]
        }
      };

    case AutomaticActionsTypes.RESET_REDUCER_BY_AUTOMATIC_ACTION_ENUM_ACTION:
      return {
        ...state,
        automaticAction: {
          data: removeByEnum(actionTypes.payload.action as AutomaticActionEnum, state.automaticAction?.data ?? [])
        }
      };

    case AutomaticActionsTypes.RESET_REDUCER_BY_ID_ACTION:

      return {
        ...state,
        automaticAction: {
          data: removeById(actionTypes.payload.action as string, state.automaticAction?.data ?? [])
        }
      };


    case AutomaticActionsTypes.RESET_ALL_REDUCER_ACTION:
      return {
        ...state,
        automaticAction: INITIAL_STATE.automaticAction
      };
    default:
      return state;
  }
};

export default automaticActionReducer;
